import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
      <div className="text-center">
        <div className="mb-4">
          <h1 className="display-1 fw-bold" style={{ letterSpacing: '6px' }}>404</h1>
          <p className="lead text-muted mb-0">We couldn't find that page.</p>
          <p className="text-muted">It may have been moved, deleted, or never existed.</p>
        </div>

        <div className="d-flex gap-2 justify-content-center">
          <Link to="/" className="btn btn-primary">
            Go Home
          </Link>
          <button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>

        <div className="mt-4 small text-muted">
          <span>Tip: Check the URL or use the navigation above.</span>
        </div>
      </div>
    </div>
  );
}

export default NotFound;

